// Api接口小飞接口
//const server = 'http://192.168.3.12:8071/';
// export default server;

//测试
//const server = 'http://test.jk-cloud.com.cn/api/';

//正式
const server = 'https://iwy.jk-cloud.com.cn/api/';


export default server;

